window.PXUTheme = window.PXUTheme || {};

window.PXUTheme.jsBundle = {
  async init($section) {
    // Merge settings into the current object
    Object.assign(this, window.PXUTheme.getSectionData($section));

    // Selectors
    this._data = window.PXUTheme.getSectionData($section);
    this.optionsHTML = document.querySelector('.product-bundle__options');
    this.addToCartBtn = document.querySelector('[data-bundle-atc-btn]');
    this.priceEl = document.querySelector('[data-bundle-price]');
    this.comparePriceEl = document.querySelector('[data-bundle-compare-price]');
    this.priceSavingsEl = document.querySelector('[data-bundle-price-savings]');
    this.reviewsButton = document.querySelector('[data-reviews-button]');

    this.watchAccordions();
    this.watchReviewsButton();

    try {
      const dynamicBoxData = await this.getBundleData(); // Await the async function
      this.bundleData = dynamicBoxData;
      this.minimumItems = this.bundleData.sizeRange[1];
      this.watchCartBtn();
      this.renderOptions();
      this.setPricing();
    } catch (e) {
      console.error(e);
    }
  },

  watchSwappers() {
    const variantSelectors = document.querySelectorAll('[data-swapper]');
  
    if (variantSelectors.length === 0) {
      console.warn('No variant swappers found.');
      return;
    }
  
    variantSelectors.forEach((swapper) => {
      swapper.addEventListener('change', (event) => {  
        // Use the correct attribute selectors to find the checked inputs
        const input1value = document.querySelector('input[name="items[0][id]"]:checked')?.value || null;
        const input2value = document.querySelector('input[name="items[1][id]"]:checked')?.value || null;
  
        if (input1value && input2value) {
          this.addToCartBtn.classList.remove('disabled');
        }
      });
    });
  },

  watchReviewsButton() {
    this.reviewsButton.addEventListener('click', (event) => {
      event.preventDefault();

      let reviewsSection = document.querySelector(".product_reviews_container") || false;
      if(reviewsSection) {
        reviewsSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  },

  watchAccordions() {
    const accordions = document.querySelectorAll('.product-bundle__accordion');

    accordions.forEach((accordion) => {
      const content = accordion.querySelector('.product-bundle__accordion-content');
    
      // Check if accordion has 'active' class by default
      if (accordion.classList.contains('active')) {
        content.style.maxHeight = `${content.scrollHeight}px`; // Set dynamic height for active accordions
      }
    
      accordion.querySelector('.product-bundle__accordion-title').addEventListener('click', () => {
        if (accordion.classList.contains('active')) {
          content.style.maxHeight = '0';
          accordion.classList.remove('active');
        } else {
          content.style.maxHeight = `${content.scrollHeight}px`;
          accordion.classList.add('active');
        }
      });
    });
  },

  setPricing() {
    const discount = this.bundleData.percentDiscountTier[2];
    const parentProd = this._data.actual_prices[1];
    console.log(parentProd);
    const price = parentProd.price / 100 * (100-discount);
    let comparePrice = parentProd.price;

    if(comparePrice == 0) {
      comparePrice = price;
    }

    this.priceEl.textContent = Shopify.formatMoney(price, document.body.getAttribute("data-money-format"));
    this.comparePriceEl.textContent = Shopify.formatMoney(comparePrice, document.body.getAttribute("data-money-format"));
    this.priceSavingsEl.textContent = `Buy two and save ${discount}%`;
    this.priceSavingsEl.classList.remove('hidden');
  },

  watchCartBtn() {
    this.addToCartBtn.addEventListener('click', (event) => {
      event.preventDefault();
      this.addItemsToCart();
    });
  },


  async getBundleData() {
    const productId = this._data.product_id;
    const fetchDynamicBoxInformation = async (productId) => {
      return new Promise((resolve, reject) => {
        fetch('https://api.skio.com/storefront-http/get-dynamic-box', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            productPlatformId: productId,
          }),
        })
          .then((response) => {
            if (!response.ok) throw new Error('Failed to get box');
            return response.json();
          })
          .then((responseData) => {
            const { DynamicBox } = responseData;
            resolve(DynamicBox);
          })
          .catch((error) => {
            console.error("Fetch error:", error);
            reject(error);
          });
      });
    };
    return await fetchDynamicBoxInformation(productId);
  },

  renderOptions() {
    let html = '';
    const variants = this.bundleData.selectableProductVariants[0].productVariants;

    for (let i = 0; i < this.minimumItems; i++) {
      html += `<div class="product-bundle__option">
        <p>Select brush ${i+1} colour: <span data-selected-colour></span>
        <div class="product-bundle__option-labels">
          ${variants.map((variant) => `
            <span>
              <input 
                type="radio"
                name="items[${i}][id]"
                value="${variant.platformId.split('/').pop()}"
                style="background-color: var(--colour-${variant.productVariantTitle.split(' / ')[0].toLowerCase().replaceAll(' ', '-')})"
                data-swapper="${variant.productVariantTitle.split(' / ')[0].toLowerCase().replaceAll(' ', '-')}"
                data-title="${variant.productVariantTitle.split(' / ')[0]}"
              />
              <span style="color: var(--checkmark-${variant.productVariantTitle.split(' / ')[0].toLowerCase().replaceAll(' ', '-')})"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none"><path d="M5 12.5531L5.8588 11.6647L9.90111 15.6478L18.1116 7.46692L19 8.34793L9.90111 17.4098L5 12.5531Z" /></svg></span>
            </span>
          `).join("")}
        </div>
      </div>`;
    }
    
    this.optionsHTML.innerHTML = html;

    if(window.PXUTheme.jsSmartGallery) {
      window.PXUTheme.jsSmartGallery.watchSwappers();
    }

    this.watchSwappers();
  },

  addItemsToCart() {
    const itemData = {items: []};
    for (let i = 0; i < this.minimumItems; i++) {
      itemData.items.push({
        id: document.querySelector(`input[name="items[${i}][id]"]:checked`).value,
        quantity: 1,
        "properties": {
          "_dynamicBoxIndex": 0,
          "_dynamicBoxId": this.bundleData.boxId
        }
      })
    }

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(itemData)
    })
    .then(response => {
      // Find the section by data-section-id attribute
      var $section = $('div#theme-ajax-cart');

      // Check if the section exists
      if ($section.length) {
        // Reinitialize jsAjaxCart with the section
        window.PXUTheme.jsAjaxCart.init($section);
        window.PXUTheme.jsAjaxCart.showDrawer();
      } else {
        console.error('Section with data-section-id="theme-ajax-cart" not found.');
      }
    })
    .catch((error) => {
      console.error('Error:', error);
    });
  }
};
